import { isSHA3Hash, type SHA3Hash, } from "@bracket/types";
import { keccak256, Memory, Sha3Wasm } from "@hazae41/sha3.wasm";


let loaded = false;
let loading = false;
( async () => {
	if(!loaded && !loading) {
		loading = true;
		await Sha3Wasm.initBundled();
		loaded = true;
		loading = false;
	}
})();

export const hashKK256Sync = ( contents: string | object): SHA3Hash => {
	if(!loaded || !loading) {
		if(loading) {
			throw new Error("@bracket/parlance: SHA3 is still loading... if it's very early in runtime, wait for it to load");
		}
		throw new Error("@bracket/parlance: SHA3 is not initialized... if it's very early in runtime, this needs to be called prior to gain benefit from the SHA3 aspects of this library");
	}
	const str = typeof contents === "string" ? contents : JSON.stringify(contents);
	const encode = new TextEncoder().encode(str);
	using memory = new Memory(encode)
	using digest = keccak256(memory);
	const { bytes } = digest;
	const result = `0x${Buffer.from(bytes).toString("hex")}`;
	if(isSHA3Hash(result)) {
		return result;
	}
	throw new Error(`@bracket/parlance: Invalid SHA3 hash: ${result}`);
}


export const hashKK256 = async ( contents: string | object): Promise<SHA3Hash> => {
	await Sha3Wasm.initBundled();
	const str = typeof contents === "string" ? contents : JSON.stringify(contents);
	const encode = new TextEncoder().encode(str);
	using memory = new Memory(encode)
	using digest = keccak256(memory);
	const { bytes } = digest;
	const result = `0x${Buffer.from(bytes).toString("hex")}`;
	if(isSHA3Hash(result)) {
		return result;
	}
	throw new Error(`@bracket/parlance: Invalid SHA3 hash: ${result}`);
}
